import { Text } from '@chakra-ui/react'

import { FaqEditor } from '../../FaqEditor'
import { SeriesForm } from './eventSeriesFormShared'

interface IProps {
  form: SeriesForm
  patchSeries: (patch: Partial<SeriesForm>) => void
  fieldErrors: Record<string, string[]>
  saving: boolean
}

export function FaqTab({ form, patchSeries, fieldErrors, saving }: IProps) {
  return (
    <>
      <Text variant="caption" mb={4}>
        Perguntas e respostas da série. Elas são exibidas em todos os eventos desta série, somadas às perguntas próprias
        de cada evento.
      </Text>
      <FaqEditor
        faqs={form.faqs}
        onChange={(next) => patchSeries({ faqs: next })}
        disabled={saving}
        fieldErrors={fieldErrors}
      />
    </>
  )
}
